var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('VBtn',{staticClass:"w-expander",class:{expanded: _vm.isExpanded},attrs:{"ripple":false,"icon":"","small":""},on:{"click":_vm.toggle}},[_c('VIcon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }